import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadScoringReportService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/leadScoringReport";

  searchLeadScoringReport(query: string, page: number, size: number, sort: string): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null // Remove single quotes from the query
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; // Construct query parameters

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  searchLeadScoringReportNew(query: string, page: number, size: number, sort: string): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null // Remove single quotes from the query
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; // Construct query parameters

    return this.http.post<Response[]>(`${this.url}/condition/new${queryParams}`, requestBody);
  }

  searchLeadScoringReportNewExcel(query: string, page: number, size: number, sort: string, groupBy: any, columnsConfig: any): Observable<any> {
    return this.searchLeadScoringReportNew(query, page, size, sort).pipe(
      map((res: any) => {
        let content = res['content'];
        if (content && columnsConfig && Array.isArray(columnsConfig)) {
          res['content'] = content.map((item: any) => {
            let newItem: any = {};
            for (let col of columnsConfig) {
              newItem[col.name] = item[col.property];
            }
            return newItem;
          });
        }
        return res;
      })
    );
  }

  downloadapproveTransactions(): Observable<any> {
    return this.http.get(`${this.url}/export`, { responseType: 'arraybuffer', observe: 'response' });
  }

  getapproveTransactions(Page: number, size: number, sort: number): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
}
